import React from "react";
import {v4 as uuidv4} from 'uuid';
import _ from 'lodash';
import { CAN_I_SWITCH } from "../../../../auto/js/events/Gui";
import { pojoMetadata, getServiceUri, metadataLoader } from "../../../../auto/js/metadata";
import { rest, t } from "../../../../auto/js/services";
import { showNotification, swapObject } from "../../../../auto/js/utils";
import { AlertDialog } from "../../../../auto/js/widgets/Dialogs";
import { createFormComponent } from "../../../../auto/js/widgets/FormComponent";
import { customSignatureRequestForm2Dto, customSignatureRequestDto2Form, getContext, isReadOnly } from "../../../../main/js/forms/signatureRequest/SignatureRequestFormCommon";
import { memstore } from "../../../../auto/js/Memstore";
import * as Yup from 'yup';
import dayjs from "dayjs";

import {
    idDisplay,
	partiesComponentHook
} from "../../../../main/js/forms/signatureRequest/SignatureRequestFormCommon";
import { formState } from "../FormState";

export const signatureRequestFields = [
    
				{
        name: "id",
        label: "id",
        type: "number",
        x: "1",
        y: "1",
        layout: "col-md-4",
        display: (data) => idDisplay(data),
        },
        {
            name: "title",
            label: "Title",
            type: "text",
            x: "1",
            y: "2",
            layout: "col-md-4"
        }
,
    
				{
        name: "documents",
        label: "documents",
        type: "file",
        x: "1",
        y: "3",
        layout: "col-md-12",
        uploadUrl: (id) => getSignatureRequestDocumentsUploadUrl(id),
        previewUrl: (id) => getSignatureRequestDocumentsPreviewUrl(id),
        loadData: async (id) => await loadSignatureRequestDocumentsData(id),
        handleDelete:(id) => handleSignatureRequestDocumentsDelete(id),
        handleClick: (id) => handleSignatureRequestDocumentsClick(id),
        updateFileData: (data) => updateSignatureRequestDocumentsData(data),
        }
,
    
				{
        name: "parties",
        label: "parties",
        type: "custom",
        x: "1",
        y: "4",
        layout: "col-md-12",
        component: (name, disabled, data, gui) => partiesComponentHook(name, disabled, data, gui),
        }

]

const getSignatureRequestDocumentsUploadUrl = (id) => {
    return getServiceUri() + 'signature-request/documents' + '/' + id;
};
const handleSignatureRequestDocumentsClick = async (id) => {
	const token = await rest.getToken(getServiceUri() + 'token/get-auth-code');
	window.location = getServiceUri() + 'signature-request/documents' + '/' + id + '/' + token;
};
const getSignatureRequestDocumentsPreviewUrl = (id) => {
	return getServiceUri() + 'signature-request/documents' + '/preview/' + id + '/';
};
const updateSignatureRequestDocumentsData = (data) => {
	let filter = {name: data.fileName, description: data.description};
	rest.request(getServiceUri() + 'signature-request/documents' + '/' + data.id, "PUT", filter);
};
const handleSignatureRequestDocumentsDelete = (id) => {
	rest.delete('signature-request/documents', id).then(() => {
		DELETE_ATTACHMENT_EVENT.publish(id)
	});
};
const loadSignatureRequestDocumentsData = async (id) => {
	let filter = {and: true};
	filter['signature-request-documents'] = {};
	filter['signature-request-documents']['signatureRequestId'] = id;
	return await rest.search('signature-request/documents', filter)
}

export const form2dtoSignatureRequest = (formData) => {
	let dto = {};
	if (customSignatureRequestForm2Dto) { 
		dto = customSignatureRequestForm2Dto(formData);
	} else
        dto = formData;
    if (formData.id != null && formData.id != "") {
        dto.id = parseInt(formData.id)
    }
    return dto;
}

export const dto2formSignatureRequest = (dto, token) => {
    let form =  _.clone(dto);
    if (customSignatureRequestDto2Form) { 
    	form = customSignatureRequestDto2Form(form, token);
	}
    formState.addState("data", form)
    return form;
}


class FormComponent extends React.Component {
	constructor(props) {
		super(props);
		this.myRef = React.createRef()
		CAN_I_SWITCH.pickUpThePhone(this.listen);
		this.state = {
			closeRequested: undefined
		}
    }

	listen = (closeMe) => {
		if (!this.isDirty())
			closeMe(true);
		this.setState({closeRequested: closeMe})
	}

	isDirty = () => {
		return this.myRef.current.isDirty();
	}

	handleDialogCancel = () => {
		this.state.closeRequested(false);
		this.setState({closeRequested: undefined});
	}

	handleSave = () => {
		this.myRef.current.save().then(() => {
			this.state.closeRequested(true);
		});
	}

	handleDontSave = () => {
		this.state.closeRequested(true);
	}

	render() {
	    let SignatureRequestForm = createFormComponent(signatureRequestFields, this.props.gui);
		return (
		<>
			<AlertDialog
				title={t`Save your changes ?`}
				open={(this.state.closeRequested && this.isDirty())?true:false}
				handleClose={this.handleDialogCancel}
				noAgree={true}
				save={this.handleSave}
				dontSave={() => this.handleDontSave(this.props.id)}
			/>
			<SignatureRequestForm readOnly={(isReadOnly)?isReadOnly():false} ref={this.myRef} key={this.props.key} loadData={this.props.loadData} onSubmit={this.props.onSubmit} id={this.props.id} buttons={(data) => null} />
		</>
		)
	}
}

export const displayNewSignatureRequestSidePanel = (gui, onFinish, formData, title) => {
	const readNewSignatureRequestSidePanel = (onFinish) => (id) => {
        let uuid = uuidv4();
           gui.openSidePanel(<FormComponent key={uuid} gui={gui} onFinish={onFinish} loadData={async () => loadFormData(id)} onSubmit={(onFinish)?(data) => update(data).then(() => onFinish()):update} id={id}/>, (title)?title:"")
    }
    let data;
    if (!formData) {
        data = buildEmptyObject(signatureRequestFields);
        data.draft = true;
        save(data).then((response) => {
            readNewSignatureRequestSidePanel(onFinish)(response)
        });
    } else {
        data = _.clone(formData);
        data.draft = true;
       	data = form2dtoSignatureRequest(formData);
        if (formData.image) {
            if (!formData.image.isEmpty) {
                let base64Image = formData.image.url;
                fetch(base64Image)
                .then(res => res.blob())
                .then(blob => {
                    let faceMimeType = "image/png";
                    data.face = blob;
                    data.faceMimeType = faceMimeType;
                    const reader = new FileReader();
                    reader.onloadend = () => {
                        data.image.url = reader.result;
                        save(data).then((response) => {
                            readNewSignatureRequestSidePanel(onFinish)(response)
                        });
                    };
                    reader.readAsDataURL(blob);
                });
            } else {
                save(data).then((response) => {
                    readNewSignatureRequestSidePanel(onFinish)(response)
                });
            }
        } else {
            save(data).then((response) => {
                readNewSignatureRequestSidePanel(onFinish)(response)
            });
        }
    }
}

export const displayNewSignatureRequestModal = (gui, onFinish, formData, title) => {
	const readNewSignatureRequestModal = (onFinish) => (id) => {
        let uuid = uuidv4();
           gui.openModal(<FormComponent key={uuid} gui={gui} onFinish={onFinish} loadData={async () => loadFormData(id)} onSubmit={(onFinish)?(data) => update(data).then(() => onFinish()):update} id={id}/>, (title)?title:"")
    }
    let data;
    if (!formData) {
        data = buildEmptyObject(signatureRequestFields);
        data.draft = true;
        save(data).then((response) => {
            readNewSignatureRequestModal(onFinish)(response)
        });
    } else {
        data = _.clone(formData);
        data.draft = true;
       	data = form2dtoSignatureRequest(formData);
        if (formData.image) {
            if (!formData.image.isEmpty) {
                let base64Image = formData.image.url;
                fetch(base64Image)
                .then(res => res.blob())
                .then(blob => {
                    let faceMimeType = "image/png";
                    data.face = blob;
                    data.faceMimeType = faceMimeType;
                    const reader = new FileReader();
                    reader.onloadend = () => {
                        data.image.url = reader.result;
                        save(data).then((response) => {
                            readNewSignatureRequestModal(onFinish)(response)
                        });
                    };
                    reader.readAsDataURL(blob);
                });
            } else {
                save(data).then((response) => {
                    readNewSignatureRequestModal(onFinish)(response)
                });
            }
        } else {
            save(data).then((response) => {
                readNewSignatureRequestModal(onFinish)(response)
            });
        }
    }
}

export const displayNewSignatureRequestForm = (gui, onFinish, formData) => {
	const readNewSignatureRequestForm = (onFinish) => (id) => {
        let uuid = uuidv4();
        return {
            uuid, view: () => <FormComponent key={uuid} gui={gui} loadData={async () => loadFormData(id)} onSubmit={(onFinish)?(data) => update(data).then((response) => onFinish(response)):update} id={id}/>, getContext: (getContext) && getContext(gui, onFinish)
        };

    }
    let data;
    if (!formData) {
        data = buildEmptyObject(signatureRequestFields);
        data.draft = true;
        save(data).then((response) => {
            gui.goTo(readNewSignatureRequestForm(onFinish), response)
        });

    } else {
        data = _.clone(formData);
        data.draft = true;
        data = form2dtoSignatureRequest(formData);
        if (formData.image) {
            if (!formData.image.isEmpty) {
                let base64Image = formData.image.url;
                fetch(base64Image)
                .then(res => res.blob())
                .then(blob => {
                    let faceMimeType = "image/png";
                    data.face = blob;
                    data.faceMimeType = faceMimeType;
                    const reader = new FileReader();
                    reader.onloadend = () => {
                        data.image.url = reader.result;
                        save(data).then((response) => {
                            gui.goTo(readNewSignatureRequestForm(onFinish), response)
                        });
                    };
                    reader.readAsDataURL(blob);
                });
            } else {
                save(data).then((response) => {
                    gui.goTo(readNewSignatureRequestForm(onFinish), response)
                });
            }
        } else {
            save(data).then((response) => {
                gui.goTo(readNewSignatureRequestForm(onFinish), response)
            });
        }
    }
}

export const displayReadSignatureRequestForm = (gui, onFinish) => (id) => {
	let uuid = uuidv4();
	return {
		uuid, view: () => <FormComponent key={uuid} loadData={async () => loadFormData(id)} onSubmit={(onFinish)?(data) => update(data).then(() => onFinish()):update} id={id}/>, getContext: (getContext) && getContext(gui, onFinish)
	};
}
export const displayReadSignatureRequestSidePanel = (gui, id, onFinish, title) => {
	const readReadSignatureRequestSidePanel = (onFinish) => (id) => {
		let uuid = uuidv4();
		gui.openSidePanel(<FormComponent key={uuid} gui={gui} loadData={(memstore.get("signatureRequest", id))?async () => {return memstore.get("signatureRequest", id).data}:async () => loadFormData(id)} onSubmit={(onFinish)?(data) => update(data).then(() => onFinish()):update} id={id}/>, (title)?title:"", (getContext) && getContext(gui, onFinish));
	}
	readReadSignatureRequestSidePanel(onFinish)(id);
}

const buildEmptyObject = (fields) => {
	const empty = {};
	for (let i = 0; i < fields.length; i++) {
		let field = fields[i];
		switch (field.type) {
			case ("text"):
				empty[field.name] = "";
				break;
			case ("number"):
				empty[field.name] = "";
				break;
			case ("checkbox"):
				empty[field.name] = false;
				break;
			case ("timestampz"):
				empty[field.name] = '';
				break;
			case ("date"):
				empty[field.name] = null;
				break;
			case ("select"): // dynamic lists, loaded from the backend
				empty[field.name] = '';
				break;
			case ("list"): // static lists, hardcoded
				empty[field.name] = '';
				break;
			case ("password"):
				empty[field.name] = '';
				break;
            case ("image"):
                empty[field.name] = null;
                break;
		}
	}
	return empty;
}

export const loadFormData = async (id) => {
    let token = await rest.getToken(getServiceUri() + 'token/get-auth-code');
	return await rest.read('signature-request', id).then(response => {
		let form = dto2formSignatureRequest(response, token);
		return form;
	})
}

export const save = async (formData) => {
	let data = _.clone(formData);
	let dto = pojoMetadata['signature-request'].form2dto(data);
	dto = form2dtoSignatureRequest(dto);
	try {
        return rest.request(getServiceUri() + 'signature-request/new-document', 'POST', dto).then((response) =>{
			if (response.status)
				showNotification(response.message.split('Detail: ')[1], "error")
				return response;
		});
    } catch (err) {
        alert(err);
    }
}

export const update = async (formData) => {
	let data = _.clone(formData);
	let dto = pojoMetadata['signature-request'].form2dto(data);
	dto = form2dtoSignatureRequest(dto)
	dto.draft = false;
	try {
        return rest.request(getServiceUri() + 'signature-request/edit-document', 'POST', dto).then((response) =>{
			if (response.status)
				showNotification(response.message.split('Detail: ')[1], "error")
		});
    } catch (err) {
        alert(err);
    }
}